export default function truncateFileName(name, maxLength = 30) {
    if (name.length <= maxLength)
        return name;
    const extIndex = name.lastIndexOf(".");
    const ext = extIndex > 0 ? name.slice(extIndex) : "";
    const dots = "..";
    const prefixLength = Math.max(12, maxLength - ext.length - dots.length);
    return name.slice(0, prefixLength) + dots + ext;
}
export const formatEventDate = (dateString) => {
    const eventDate = new Date(dateString);
    const eventDateBR = new Date(eventDate.toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo",
    }));
    const nowBR = new Date(new Date().toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo",
    }));
    const time = eventDateBR.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
    });
    const startOfToday = new Date(nowBR);
    startOfToday.setHours(0, 0, 0, 0);
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);
    if (eventDateBR >= startOfToday) {
        return `Hoje - ${time}`;
    }
    if (eventDateBR >= startOfYesterday) {
        return `Ontem - ${time}`;
    }
    const date = eventDateBR.toLocaleDateString("pt-BR");
    return `${date} - ${time}`;
};
export const formatHour = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 4).split("");
    let [h1, h2, m1, m2] = digits;
    if (h1 && Number(h1) > 2)
        h1 = "2";
    if (h1 === "2" && h2 && Number(h2) > 3)
        h2 = "3";
    if (m1 && Number(m1) > 5)
        m1 = "5";
    const numbers = [h1, h2, m1, m2].filter(Boolean).join("");
    if (numbers.length <= 2)
        return numbers;
    return numbers.replace(/^(\d{2})(\d{1,2})$/, "$1:$2");
};
export function parseBrazilianDate(date) {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
}
export function parseBRDate(value) {
    if (!value)
        return null;
    const [day, month, year] = value.split("/").map(Number);
    if (!day || !month || !year)
        return null;
    const date = new Date(year, month - 1, day);
    if (Number.isNaN(date.getTime()))
        return null;
    return date;
}
export function formatBRDate(date) {
    if (!date)
        return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}
